import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { AplixInput } from '../../../../../../components';

interface IProps {
    show: boolean;
    kunde: string;
    information?: string;
    onClose: () => void;
}

function Transition(props: any) {
    return <Slide direction="down" {...props} />;
}

export const ContractInfoDialog = ({ show, kunde, information, onClose }: IProps) => {
    return (
        <Dialog
            open={show}
            TransitionComponent={Transition}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
        >
            <DialogTitle id="alert-dialog-title">{'Auftragsinformationen'}</DialogTitle>
            <DialogContent>
                <AplixInput
                    id="customer"
                    label="Kunde"
                    value={kunde}
                    placeholder="Keine Angabe"
                    disabled
                    fullWidth
                    multiline
                />
                <AplixInput
                    id="notes"
                    label="Bemerkungen / Rüsthinweise"
                    value={information}
                    placeholder="Keine Angaben"
                    disabled
                    fullWidth
                    multiline
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" autoFocus variant="contained">
                    Schliessen
                </Button>
            </DialogActions>
        </Dialog>
    );
};
